module.exports = __webpack_public_path__ + "static/media/effect-left.b932286e.png";